import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class EsMarcaClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getEsMarca(queries = {}) {
    try {
      const { data } = await this.api.get('/marcas', { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as marcas');
    }
  }

  async obterMarcarPorCodMarca(codMarcaId) {
    try {
      const { data } = await this.api.get(`/marcas/catalogoMarca/${codMarcaId}`);
      return data;
    } catch (error) {
      throw this.error.message(error, `Erro ao obter a marca: ${codMarcaId}`);
    }
  }

  async listarCategoriasPorMarca(codMarcaId) {
    try {
      const { data } = await this.api.get(`/marcas/catalogoMarca/${codMarcaId}/categorias`);
      return data;
    } catch (error) {
      throw this.error.message(error, `Erro ao obter a marca: ${codMarcaId}`);
    }
  }

  async listarReferenciasPorCategoriaCodMarca(codMarcaId, codCategoria) {
    try {
      const { data } = await this.api.get(`/marcas/catalogoMarca/${codMarcaId}/categorias/${codCategoria}/referencias`);
      return data;
    } catch (error) {
      throw this.error.message(error, `Erro ao obter a marca: ${codMarcaId}`);
    }
  }

  async listarImagensPorMarca(codMarcaId, querie = {}) {
    try {
      const { data } = await this.api.get(`/marcas/catalogoMarca/${codMarcaId}/imagens`, { params: querie });
      return data;
    } catch (error) {
      throw this.error.message(error, `Erro ao obter a marca: ${codMarcaId}`);
    }
  }
}
